import { IOfferCard } from '../../../../types';
import { isAgent } from '../../utils/isAgent';
import { getRentPrice, getRentPriceInfo, getSalePrice, getSalePriceInfo } from '../../utils';

export const preparePrice = (offerCard: IOfferCard) => {
  const { dealType, discount } = offerCard;
  const isUserAgent = isAgent(offerCard);

  return dealType === 'rent'
    ? {
        price: getRentPrice(offerCard),
        priceInfo: getRentPriceInfo(offerCard, isUserAgent),
        discount,
      }
    : {
        price: getSalePrice(offerCard),
        priceInfo: getSalePriceInfo(offerCard, isUserAgent),
        discount,
      };
};
